import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { PLAN_LABEL } from '../../utils/license';

const sections = [
  {
    id: 'novidades',
    icon: 'fa-star',
    color: 'var(--gold)',
    title: 'Novidades',
    topics: [
      {
        title: '🤖 Consultor IA — análises com inteligência artificial',
        content: (
          <>
            <p>O <strong>Consultor IA</strong> usa seus dados financeiros reais para gerar análises personalizadas com Google Gemini.</p>
            <ul>
              <li><strong>7 capítulos</strong> cobrindo gastos, economias, metas, plano mensal, rotina, investimentos e consistência</li>
              <li><strong>20 análises</strong> prontas — clique em "Analisar" e receba insights do seu dinheiro em segundos</li>
              <li>Quanto mais dados você lançar, mais precisa a análise fica</li>
            </ul>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>Disponível no menu <strong>PLANEJAMENTO → Consultor IA</strong>. Exclusivo para planos Pro e Família.</span>
            </div>
          </>
        ),
      },
      {
        title: '💳 Baixa parcial de dívidas com histórico',
        content: (
          <>
            <p>Agora ao registrar um pagamento de dívida você pode:</p>
            <ul>
              <li>Informar o <strong>valor pago parcialmente</strong> (não precisa quitar tudo de uma vez)</li>
              <li>Escolher a <strong>data exata</strong> do pagamento</li>
              <li>Adicionar uma <strong>observação</strong> (ex: "Parcela de junho")</li>
              <li>Ver o <strong>histórico completo</strong> de todas as baixas diretamente no card da dívida</li>
            </ul>
            <p>O saldo devedor é atualizado automaticamente a cada pagamento.</p>
          </>
        ),
      },
      {
        title: '👨‍👩‍👧 Plano Família — finanças compartilhadas',
        content: (
          <>
            <p>O <strong>Plano Família</strong> permite que vários membros usem o mesmo sistema financeiro:</p>
            <ol>
              <li>O titular cria uma família em <strong>Configurações → Criar família</strong></li>
              <li>Compartilha o <strong>código da família</strong> com os membros</li>
              <li>Os membros entram com o código em <strong>Configurações → Entrar em família</strong></li>
              <li>Todos passam a ver e lançar nos mesmos dados em tempo real</li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-shield-halved"></i>
              <span>Todos os dados são sincronizados na nuvem automaticamente entre os dispositivos da família.</span>
            </div>
          </>
        ),
      },
      {
        title: '🔒 Proteção de dados — 4 camadas de segurança',
        content: (
          <>
            <p>Seus dados têm <strong>4 camadas de proteção</strong> contra perda acidental:</p>
            <ul>
              <li><strong>Backup diário automático</strong> — salvo localmente todo dia</li>
              <li><strong>Backup pré-sincronização</strong> — salvo antes de qualquer operação na nuvem</li>
              <li><strong>Proteção contra regressão</strong> — bloqueia salvamentos que reduzam mais de 50% dos dados</li>
              <li><strong>Exportação manual</strong> — disponível em Configurações → Exportar dados</li>
            </ul>
            <div className="help-tip">
              <i className="fas fa-rotate"></i>
              <span>Em Configurações você pode ver os dois últimos backups e restaurá-los a qualquer momento.</span>
            </div>
          </>
        ),
      },
      {
        title: '📊 Relatório de Cartão',
        content: (
          <>
            <p>Acompanhe seus gastos no cartão de crédito em detalhes:</p>
            <ul>
              <li><strong>Gráfico de pizza</strong> com gastos por categoria</li>
              <li><strong>Gráfico de barras</strong> comparando meses anteriores</li>
              <li>Filtro por cartão e por período</li>
            </ul>
            <p>Acesse em <strong>Menu → Relatório de Cartão</strong>. Disponível nos planos Pro e Família.</p>
          </>
        ),
      },
    ],
  },
  {
    id: 'primeiros-passos',
    icon: 'fa-rocket',
    color: '#1d9e75',
    title: 'Primeiros Passos',
    topics: [
      {
        title: 'Como fazer login',
        content: (
          <>
            <p>Ao abrir o MAW Finanças pela primeira vez você verá a tela de login.</p>
            <ol>
              <li>Digite um <strong>nome de usuário</strong> e um <strong>e-mail</strong></li>
              <li>Crie uma <strong>senha</strong> (mínimo 6 caracteres)</li>
              <li>Clique em <strong>Entrar</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>Quer experimentar sem criar conta? Clique em <strong>Modo Demonstração</strong> na tela de login.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Entendendo o Dashboard',
        content: (
          <>
            <p>O Dashboard é a página principal. Nele você vê um resumo completo das suas finanças:</p>
            <ul>
              <li><strong>Saldo Total</strong> — soma de todas as suas contas</li>
              <li><strong>Receitas do mês</strong> — tudo que entrou no mês atual</li>
              <li><strong>Despesas do mês</strong> — tudo que saiu no mês atual</li>
              <li><strong>Meta de economia</strong> — barra de progresso com quanto você já guardou</li>
              <li><strong>Gráfico de categorias</strong> — onde seu dinheiro está sendo gasto</li>
              <li><strong>Últimas transações</strong> — os lançamentos mais recentes</li>
            </ul>
          </>
        ),
      },
      {
        title: 'Navegando pelo sistema',
        content: (
          <>
            <p>Use o menu lateral esquerdo para acessar os módulos:</p>
            <ul>
              <li><i className="fas fa-house" style={{color:'var(--blue)',marginRight:6}}></i><strong>Dashboard</strong> — visão geral</li>
              <li><i className="fas fa-credit-card" style={{color:'var(--blue)',marginRight:6}}></i><strong>Contas e Cartões</strong> — gerencie suas contas</li>
              <li><i className="fas fa-list-ul" style={{color:'var(--blue)',marginRight:6}}></i><strong>Lançamentos</strong> — receitas e despesas</li>
              <li><i className="fas fa-tag" style={{color:'var(--blue)',marginRight:6}}></i><strong>Categorias</strong> — organize por tipo</li>
              <li><i className="fas fa-file-invoice-dollar" style={{color:'var(--blue)',marginRight:6}}></i><strong>Dívidas</strong> — controle de passivos</li>
              <li><i className="fas fa-calendar" style={{color:'var(--gold)',marginRight:6}}></i><strong>Calendário</strong> — visualização mensal <em>(Pro/Família)</em></li>
              <li><i className="fas fa-chart-line" style={{color:'var(--gold)',marginRight:6}}></i><strong>Resumo Anual</strong> — relatórios <em>(Pro/Família)</em></li>
              <li><i className="fas fa-chart-bar" style={{color:'var(--gold)',marginRight:6}}></i><strong>Investimentos</strong> — carteira <em>(Pro/Família)</em></li>
              <li><i className="fas fa-star" style={{color:'var(--gold)',marginRight:6}}></i><strong>Metas</strong> — objetivos financeiros <em>(Pro/Família)</em></li>
              <li><i className="fas fa-clipboard-list" style={{color:'var(--gold)',marginRight:6}}></i><strong>Orçamento</strong> — controle de gastos <em>(Pro/Família)</em></li>
              <li><i className="fas fa-robot" style={{color:'var(--gold)',marginRight:6}}></i><strong>Consultor IA</strong> — análises inteligentes <em>(Pro/Família)</em></li>
            </ul>
          </>
        ),
      },
      {
        title: 'Período de teste gratuito',
        content: (
          <>
            <p>Ao criar sua conta você tem <strong>7 dias de acesso completo</strong> a todos os módulos gratuitamente.</p>
            <ul>
              <li>O contador aparece no rodapé do menu lateral</li>
              <li>Quando restar 2 dias ou menos, um aviso aparece com link para ver os planos</li>
              <li>Após o período de teste, apenas os módulos do plano Básico ficam disponíveis</li>
            </ul>
            <div className="help-tip">
              <i className="fas fa-key"></i>
              <span>Para continuar com acesso completo, ative uma chave de licença em <strong>Configurações → Licença</strong>.</span>
            </div>
          </>
        ),
      },
    ],
  },
  {
    id: 'contas',
    icon: 'fa-credit-card',
    color: '#378ADD',
    title: 'Contas e Cartões',
    topics: [
      {
        title: 'Cadastrando uma conta bancária',
        content: (
          <>
            <p>Para registrar suas contas bancárias:</p>
            <ol>
              <li>Acesse <strong>Contas e Cartões</strong> no menu lateral</li>
              <li>Clique em <strong>+ Nova Conta</strong></li>
              <li>Preencha: nome do banco, tipo (Conta Corrente, Poupança, etc.) e saldo inicial</li>
              <li>Escolha uma cor para identificar a conta</li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>O saldo inicial deve ser o valor atual da sua conta no dia que está cadastrando.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Adicionando um cartão de crédito',
        content: (
          <>
            <p>Para adicionar um cartão de crédito:</p>
            <ol>
              <li>Em <strong>Contas e Cartões</strong>, clique em <strong>+ Novo Cartão</strong></li>
              <li>Informe: nome do cartão, limite total e dia de vencimento da fatura</li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <p>O sistema calcula automaticamente o limite disponível conforme você registra gastos no cartão.</p>
          </>
        ),
      },
      {
        title: 'Transferindo entre contas',
        content: (
          <>
            <p>Para registrar uma transferência entre suas contas:</p>
            <ol>
              <li>No Dashboard, clique em <strong>Transferência</strong></li>
              <li>Selecione a conta de <strong>origem</strong> e a conta de <strong>destino</strong></li>
              <li>Informe o valor e a data</li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <p>Os saldos das duas contas são atualizados automaticamente.</p>
          </>
        ),
      },
    ],
  },
  {
    id: 'lancamentos',
    icon: 'fa-list-ul',
    color: '#e24b4a',
    title: 'Lançamentos',
    topics: [
      {
        title: 'Registrando uma receita ou despesa',
        content: (
          <>
            <p>Para lançar uma transação:</p>
            <ol>
              <li>Acesse <strong>Lançamentos</strong> e clique em <strong>+ Novo Lançamento</strong></li>
              <li>Escolha o tipo: <strong>Receita</strong> ou <strong>Despesa</strong></li>
              <li>Preencha: descrição, valor, data, categoria e conta</li>
              <li>Defina o status: <strong>Pago</strong> ou <strong>Pendente</strong></li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>Lançamentos <strong>Pendentes</strong> aparecem no calendário como alertas e não afetam o saldo até serem marcados como pagos.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Anexando comprovante',
        content: (
          <>
            <p>Você pode anexar uma foto ou PDF ao lançamento:</p>
            <ol>
              <li>Ao criar ou editar um lançamento, clique em <strong>Anexar comprovante</strong></li>
              <li>Selecione a foto ou arquivo PDF do cupom ou nota fiscal</li>
              <li>O comprovante fica salvo na nuvem vinculado ao lançamento</li>
            </ol>
          </>
        ),
      },
      {
        title: 'Importando extrato do banco (OFX / CSV)',
        content: (
          <>
            <p>Para importar seu extrato bancário:</p>
            <ol>
              <li>No seu banco, exporte o extrato em formato <strong>OFX</strong> ou <strong>CSV</strong></li>
              <li>Em <strong>Lançamentos</strong>, clique em <strong>Importar</strong></li>
              <li>Selecione o arquivo baixado do banco</li>
              <li>Revise os lançamentos detectados e confirme</li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>A maioria dos bancos brasileiros (Itaú, Bradesco, Nubank, Santander, Inter) permite exportar OFX no internet banking.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Usando filtros avançados',
        content: (
          <>
            <p>Em <strong>Lançamentos</strong>, clique no botão de filtro para abrir o painel avançado:</p>
            <ul>
              <li><strong>Categoria</strong> — veja apenas uma categoria específica</li>
              <li><strong>Faixa de valor</strong> — filtre por valor mínimo e máximo</li>
              <li><strong>Período</strong> — selecione mês/ano ou intervalo personalizado</li>
              <li><strong>Tipo</strong> — receitas, despesas ou todos</li>
              <li><strong>Status</strong> — pago, pendente ou atrasado</li>
            </ul>
            <p>Um <strong>badge</strong> aparece no botão de filtro indicando quantos filtros estão ativos.</p>
          </>
        ),
      },
    ],
  },
  {
    id: 'dividas',
    icon: 'fa-file-invoice-dollar',
    color: '#e24b4a',
    title: 'Dívidas',
    topics: [
      {
        title: 'Cadastrando uma dívida',
        content: (
          <>
            <p>Para registrar um empréstimo, financiamento ou outra dívida:</p>
            <ol>
              <li>Acesse <strong>Dívidas</strong> no menu lateral</li>
              <li>Clique em <strong>+ Nova Dívida</strong></li>
              <li>Preencha: nome, tipo, valor total, valor restante, parcela mensal e taxa de juros</li>
              <li>Informe o <strong>dia de vencimento</strong> e as datas de início e término</li>
              <li>Clique em <strong>Criar</strong></li>
            </ol>
          </>
        ),
      },
      {
        title: 'Registrando um pagamento (baixa parcial)',
        content: (
          <>
            <p>Para registrar um pagamento parcial ou total de uma dívida:</p>
            <ol>
              <li>No card da dívida, clique em <strong>Baixar</strong></li>
              <li>Selecione a <strong>conta de débito</strong></li>
              <li>Informe o <strong>valor pago</strong> e a <strong>data do pagamento</strong></li>
              <li>Adicione uma <strong>observação</strong> se quiser (ex: "Parcela de junho")</li>
              <li>Se quiser quitar completamente, marque <strong>Quitar dívida completamente</strong></li>
              <li>Confira o novo saldo devedor no resumo e clique em <strong>Confirmar Pagamento</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>O pagamento gera automaticamente um lançamento de despesa na conta selecionada.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Visualizando o histórico de pagamentos',
        content: (
          <>
            <p>Cada dívida guarda o histórico completo de todos os pagamentos realizados:</p>
            <ul>
              <li>No card da dívida, clique em <strong>"Histórico de pagamentos (X)"</strong></li>
              <li>A lista expande mostrando: <strong>data, valor pago e observação</strong> de cada baixa</li>
              <li>O <strong>total pago acumulado</strong> aparece no cabeçalho do histórico</li>
              <li>Os pagamentos ficam ordenados do mais recente para o mais antigo</li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    id: 'consultor-ia',
    icon: 'fa-robot',
    color: '#9b59b6',
    title: 'Consultor IA',
    plan: 'pro',
    topics: [
      {
        title: 'O que é o Consultor IA',
        content: (
          <>
            <p>O <strong>Consultor IA</strong> é seu assistente financeiro pessoal powered by Google Gemini. Ele lê seus dados reais do MAW Finanças e gera análises personalizadas.</p>
            <p>São <strong>7 capítulos</strong> com <strong>20 análises</strong> cobrindo:</p>
            <ul>
              <li>Entendendo seus gastos</li>
              <li>Onde economizar</li>
              <li>Definindo metas</li>
              <li>Plano mensal</li>
              <li>Rotina financeira</li>
              <li>Começando a investir</li>
              <li>Consistência no longo prazo</li>
            </ul>
          </>
        ),
      },
      {
        title: 'Como usar o Consultor IA',
        content: (
          <>
            <ol>
              <li>Acesse <strong>PLANEJAMENTO → Consultor IA</strong> no menu lateral</li>
              <li>Clique em um capítulo para expandir as análises disponíveis</li>
              <li>Clique em <strong>Analisar</strong> em qualquer análise</li>
              <li>Aguarde alguns segundos — o Gemini vai ler seus dados e gerar a resposta</li>
              <li>Clique em <strong>Reanalisar</strong> para atualizar a qualquer momento</li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-chart-line"></i>
              <span>Quanto mais lançamentos você tiver no sistema, mais precisas e personalizadas serão as análises.</span>
            </div>
          </>
        ),
      },
    ],
  },
  {
    id: 'metas',
    icon: 'fa-star',
    color: 'var(--gold)',
    title: 'Metas Financeiras',
    plan: 'pro',
    topics: [
      {
        title: 'Criando uma meta',
        content: (
          <>
            <p>Para criar uma meta financeira:</p>
            <ol>
              <li>Acesse <strong>Metas</strong> no menu lateral</li>
              <li>Clique em <strong>+ Nova Meta</strong></li>
              <li>Preencha: nome da meta (ex: "Carro Novo"), valor objetivo e data alvo</li>
              <li>Informe quanto você já tem guardado para essa meta</li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <p>O sistema calcula automaticamente quanto você precisa guardar por mês para atingir a meta na data escolhida.</p>
          </>
        ),
      },
      {
        title: 'Meta de economia mensal',
        content: (
          <>
            <p>No <strong>Dashboard</strong> você tem um widget de meta de economia mensal:</p>
            <ul>
              <li>Clique no ícone de edição para definir quanto quer guardar por mês</li>
              <li>A barra de progresso mostra quanto você já guardou no mês atual</li>
              <li>O valor é calculado automaticamente (receitas − despesas do mês)</li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    id: 'orcamentos',
    icon: 'fa-clipboard-list',
    color: '#993556',
    title: 'Orçamento',
    plan: 'pro',
    topics: [
      {
        title: 'Criando um orçamento mensal',
        content: (
          <>
            <p>O orçamento define um limite de gastos por categoria:</p>
            <ol>
              <li>Acesse <strong>Orçamento Poderoso</strong> no menu lateral</li>
              <li>Clique em <strong>+ Novo Orçamento</strong></li>
              <li>Selecione a categoria (ex: Alimentação) e defina o limite mensal</li>
              <li>Clique em <strong>Salvar</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>Quando seus gastos naquela categoria atingirem 80% do limite, você receberá um alerta automático.</span>
            </div>
          </>
        ),
      },
    ],
  },
  {
    id: 'relatorios',
    icon: 'fa-chart-line',
    color: '#1d9e75',
    title: 'Relatórios',
    plan: 'pro',
    topics: [
      {
        title: 'Resumo Anual',
        content: (
          <>
            <p>O módulo <strong>Resumo Anual</strong> exibe:</p>
            <ul>
              <li><strong>Gráfico mensal</strong> de receitas vs. despesas do ano</li>
              <li><strong>Evolução patrimonial</strong> mês a mês</li>
              <li><strong>Ranking de categorias</strong> de maior gasto</li>
              <li><strong>Comparativo</strong> entre meses</li>
            </ul>
          </>
        ),
      },
      {
        title: 'Relatório de Cartão',
        content: (
          <>
            <p>Acompanhe seus gastos no cartão em detalhes:</p>
            <ol>
              <li>Acesse <strong>Relatório de Cartão</strong> no menu lateral</li>
              <li>Selecione o cartão e o período que deseja analisar</li>
              <li>Veja o <strong>gráfico de pizza</strong> por categoria e o <strong>histórico mensal</strong></li>
            </ol>
          </>
        ),
      },
    ],
  },
  {
    id: 'conta',
    icon: 'fa-gear',
    color: '#378ADD',
    title: 'Configurações',
    topics: [
      {
        title: 'Alterando nome e foto',
        content: (
          <>
            <p>Para personalizar seu perfil:</p>
            <ol>
              <li>Acesse <strong>Configurações</strong> no menu lateral</li>
              <li>Clique na foto para fazer upload de uma imagem</li>
              <li>Edite seu nome no campo <strong>Nome completo</strong> e clique em <strong>Salvar nome</strong></li>
            </ol>
            <div className="help-tip">
              <i className="fas fa-lightbulb"></i>
              <span>O nome é salvo na nuvem e aparece igual em todos os dispositivos onde você fizer login.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Ativando uma licença',
        content: (
          <>
            <p>Para ativar sua chave de licença:</p>
            <ol>
              <li>Acesse <strong>Configurações</strong> no menu lateral</li>
              <li>No card <strong>Licença</strong>, clique em <strong>Ativar chave</strong></li>
              <li>Digite sua chave no formato <strong>MAW-X-XXXXXX-XXXXXXXX</strong></li>
              <li>Clique em <strong>Ativar</strong></li>
            </ol>
            <p>Os módulos do seu plano são liberados imediatamente após a ativação.</p>
          </>
        ),
      },
      {
        title: 'Plano Família — multi-usuário',
        content: (
          <>
            <p><strong>Para criar uma família (titular):</strong></p>
            <ol>
              <li>Em <strong>Configurações</strong>, clique em <strong>Criar família</strong></li>
              <li>Um código único é gerado — compartilhe com os membros</li>
            </ol>
            <p><strong>Para entrar em uma família (membro):</strong></p>
            <ol>
              <li>Em <strong>Configurações</strong>, clique em <strong>Entrar em família</strong></li>
              <li>Digite o código recebido do titular</li>
              <li>Seus dados passam a ser compartilhados com a família em tempo real</li>
            </ol>
          </>
        ),
      },
      {
        title: 'Backup e exportação de dados',
        content: (
          <>
            <p>Em <strong>Configurações → Backup</strong> você tem acesso a:</p>
            <ul>
              <li><strong>Backup diário</strong> — último backup automático salvo</li>
              <li><strong>Backup pré-sincronização</strong> — salvo antes de cada operação na nuvem</li>
              <li><strong>Exportar dados</strong> — baixa um arquivo JSON com todos os seus dados</li>
            </ul>
            <div className="help-tip">
              <i className="fas fa-shield-halved"></i>
              <span>Recomendamos exportar seus dados mensalmente como segurança extra.</span>
            </div>
          </>
        ),
      },
      {
        title: 'Limpando todos os dados',
        content: (
          <>
            <p>Para apagar todos os dados da conta:</p>
            <ol>
              <li>Acesse <strong>Configurações → Zona de Perigo</strong></li>
              <li>Clique em <strong>Limpar todos os dados</strong></li>
              <li>Confirme digitando o texto solicitado</li>
            </ol>
            <div className="help-tip" style={{ background: 'rgba(226,75,74,0.08)', borderColor: '#e24b4a' }}>
              <i className="fas fa-triangle-exclamation" style={{ color: '#e24b4a' }}></i>
              <span>Esta ação apaga todos os lançamentos, contas, metas e dívidas — da tela <strong>e</strong> da nuvem. Sua <strong>licença é preservada</strong>.</span>
            </div>
          </>
        ),
      },
    ],
  },
];

function TopicItem({ topic }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`help-topic ${open ? 'open' : ''}`} onClick={() => setOpen(o => !o)}>
      <div className="help-topic-header">
        <span>{topic.title}</span>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`}></i>
      </div>
      {open && (
        <div className="help-topic-body" onClick={e => e.stopPropagation()}>
          {topic.content}
        </div>
      )}
    </div>
  );
}

export default function Help() {
  const { state } = useApp();
  const [activeSection, setActiveSection] = useState('novidades');
  const plan = state.license?.plan;
  const current = sections.find(s => s.id === activeSection);

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>Central de Ajuda</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 2 }}>Aprenda a usar todos os recursos do MAW Finanças</div>
      </div>

      <div className="help-layout">

        {/* Sidebar de navegação */}
        <div className="help-nav">
          {sections.map(s => {
            const locked = s.plan && plan === 'basico';
            const isNew = s.id === 'novidades';
            return (
              <button
                key={s.id}
                onClick={() => setActiveSection(s.id)}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 14px', borderRadius: 'var(--radius-sm)',
                  background: activeSection === s.id ? `${s.color}18` : 'transparent',
                  border: activeSection === s.id ? `1px solid ${s.color}40` : '1px solid transparent',
                  color: activeSection === s.id ? s.color : 'var(--text)',
                  fontWeight: activeSection === s.id ? 600 : 400,
                  fontSize: 13, cursor: 'pointer', textAlign: 'left',
                  marginBottom: 4, transition: 'all 0.15s',
                  opacity: locked ? 0.5 : 1,
                }}
              >
                <i className={`fas ${s.icon}`} style={{ fontSize: 13, color: s.color, width: 16 }}></i>
                <span style={{ flex: 1 }}>{s.title}</span>
                {isNew && <span style={{ fontSize: 9, background: 'var(--gold)', color: '#0d1b2a', borderRadius: 99, padding: '2px 6px', fontWeight: 700 }}>NOVO</span>}
                {locked && <i className="fas fa-lock" style={{ fontSize: 10, opacity: 0.5 }}></i>}
              </button>
            );
          })}
        </div>

        {/* Conteúdo */}
        <div className="help-body">
          {current && (
            <div className="card" style={{ padding: '24px 28px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid var(--border)' }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                  background: `${current.color}18`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <i className={`fas ${current.icon}`} style={{ color: current.color, fontSize: 16 }}></i>
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16 }}>{current.title}</div>
                  {current.plan && (
                    <div style={{ fontSize: 11, color: 'var(--gold)', fontWeight: 600, marginTop: 2 }}>
                      <i className="fas fa-lock" style={{ marginRight: 4 }}></i>
                      Disponível no plano {PLAN_LABEL[current.plan]} ou Família
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {current.topics.map((topic, i) => (
                  <TopicItem key={i} topic={topic} />
                ))}
              </div>
            </div>
          )}

          <div style={{
            marginTop: 16, padding: '16px 20px',
            background: 'var(--surface2)', borderRadius: 'var(--radius-sm)',
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <i className="fas fa-envelope" style={{ color: 'var(--blue)', fontSize: 18, flexShrink: 0 }}></i>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>Ainda tem dúvidas?</div>
              <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                Entre em contato:{' '}
                <a href="mailto:contato@financasmaw.com.br" style={{ color: 'var(--blue)', textDecoration: 'none' }}>
                  contato@financasmaw.com.br
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
